import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Mail, Phone, Clock } from 'lucide-react';
import { businessInfo, navigationLinks, contactInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-secondary border-t border-border">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex flex-col mb-6">
              <span className="font-heading text-2xl font-medium text-foreground">
                {businessInfo.name}
              </span>
              <span className="text-xs text-muted-foreground tracking-wider uppercase mt-1">
                Amma Assis en entreprise
              </span>
            </Link>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Praticienne spécialisée en Amma assis, j'interviens dans les entreprises 
              pour offrir des pauses bien-être revitalisantes à vos équipes.
            </p>
          </div>

          {/* Navigation Column */}
          <div>
            <h4 className="font-heading text-lg font-medium text-foreground mb-6">
              Navigation
            </h4>
            <nav className="flex flex-col gap-3">
              {navigationLinks.map((link) =>
              <Link
                key={link.path}
                to={link.path}
                className="text-sm text-muted-foreground hover:text-primary transition-smooth">

                  {link.name}
                </Link>
              )}
            </nav>
          </div>

          {/* Contact Column */}
          <div>
            <h4 className="font-heading text-lg font-medium text-foreground mb-6">
              Contact
            </h4>
            <ul className="flex flex-col gap-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-primary mt-0.5 flex-shrink-0" />
                <span className="text-sm text-muted-foreground">
                  {contactInfo.location}<br />
                  <span className="text-xs">Zone : {contactInfo.zone}</span>
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-primary flex-shrink-0" />
                <a
                  href={`mailto:${contactInfo.email}`}
                  className="text-sm text-muted-foreground hover:text-primary transition-smooth">

                  {contactInfo.email}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-4 h-4 text-primary flex-shrink-0" />
                <a
                  href="tel:+33600000000"
                  className="hover:text-primary transition-smooth !text-sm text-muted-foreground">

                  {contactInfo.phone}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Clock className="w-4 h-4 text-primary flex-shrink-0" />
                <span className="text-sm text-muted-foreground">
                  {contactInfo.availability}
                </span>
              </li>
            </ul>
          </div>

          {/* CTA Column */}
          <div>
            <h4 className="font-heading text-lg font-medium text-foreground mb-6">
              Entreprises
            </h4>
            <p className="text-sm text-muted-foreground mb-6 leading-relaxed">
              Vous souhaitez offrir des séances de Amma assis à vos collaborateurs ? 
              Contactez-moi pour un devis personnalisé.
            </p>
            <Link
              to="/contact"
              className="btn-primary text-center w-full">

              Demander un devis
            </Link>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-border flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-muted-foreground">
            © {currentYear} {businessInfo.name}. Tous droits réservés.
          </p>
          <p className="text-xs text-muted-foreground">
            SIRET : {businessInfo.siret}
          </p>
        </div>
      </div>
    </footer>);

};

export default Footer;